import React, { useState } from "react";
import Switch from "../../../../Switch";
import usersIcon from "assets/icons/Icon-User-Outline-Users.svg";
import { useDispatch, useSelector } from "react-redux";
import { addPretextsStart } from "../../../../../redux/chats/chats.actions";
import useTranslation from "hooks/useTranslation";
import { SmilingComponent } from "assets/icons";
import { clsx } from "clsx";

const getMaxValidCharsCount = ({ chatsData }) =>
  chatsData.maxValidCharactersCount;

const AddPretext = ({ emojis, setPretextsContent }) => {
  const [showEmojis, setShowEmojis] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    addToAll: false,
  });
  const [errors, setErrors] = useState({});
  const { getTranslation } = useTranslation("CHAT");
  const maxValidCharsCount = useSelector(getMaxValidCharsCount);
  const { t } = getTranslation();

  const dispatch = useDispatch();

  const handleToggleEmojis = () => {
    setShowEmojis(!showEmojis);
  };

  const handleToggleAddToAll = () => {
    setFormData((prev) => {
      return {
        ...prev,
        addToAll: !prev.addToAll,
      };
    });
  };

  const handleChangeForm = (value, name) => {
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getErrorsObject = () => {
    const errors = {};
    const emptyErrorText = "این فیلد نمیتواند خالی باشد";
    const exceedCharactersErrorMsg = `مقدار ارسالی بیش از ${maxValidCharsCount} کاراکتر می باشد`;
    const fields = ["title", "description"];

    for (let field of fields) {
      if (!formData[field]) {
        errors[field] = emptyErrorText;
      } else if (formData[field].length > maxValidCharsCount) {
        errors[field] = exceedCharactersErrorMsg;
      }
    }

    return errors;
  };

  const handleAddPRetext = () => {
    const errorsObject = getErrorsObject();
    setErrors(errorsObject);

    // do not continue if there is at least one error
    if (Object.keys(errorsObject).length > 0) return;

    let sendData = {
      edit: false,
      question: formData.title,
      answer: formData.description,
      addToAll: formData.addToAll,
    };

    dispatch(addPretextsStart(sendData));
  };

  const handleAddEmoji = (emoji) => {
    setFormData((prev) => {
      return {
        ...prev,
        description: prev.description + emoji,
      };
    });
  };

  return (
    <div className="add__pretext__body">
      <h2> {t("ADD_MESSAGE_TITLE")} </h2>
      <div className="flex add__pretext__body_title">
        <input
          defaultValue={formData.title}
          value={formData.title}
          type="text"
          placeholder={t("MSG_TITLE_PH")}
          // className={clsx("add__pretext__body_title_input")}
          className={clsx(
            "add__pretext__body_title_input",
            errors["title"] && "has-error"
          )}
          onChange={(e) => handleChangeForm(e.target.value, "title")}
        />
        {errors["title"] && (
          <span className="add__pretext__validation_error__text">
            {errors["title"]}
          </span>
        )}
      </div>
      <div className="add__pretext__body_description">
        <div className="add__pretext__body_description_input__wrapper">
          <textarea
            value={formData.description}
            defaultValue={formData.description}
            className={clsx(
              "add__pretext__body_description_input",
              errors["description"],
              errors["description"] && "has-error"
            )}
            placeholder={t("MSG_CONTENT_PH")}
            onChange={(e) => handleChangeForm(e.target.value, "description")}
          />

          <div className="flex flex-jc-e add__pretext__body_description_input_emoji">
            <div
              onClick={() => {
                handleToggleEmojis();
              }}
              className="conv__body__footer__actions__icon__emoji flex flex-ai-c flex-jc-c"
            >
              <SmilingComponent />
            </div>
            {showEmojis && (
              <div className="add__pretext__body_description_emojis_container">
                {emojis.map((emoji) => (
                  <span onClick={() => handleAddEmoji(emoji)}>{emoji}</span>
                ))}
              </div>
            )}
          </div>
        </div>

        {errors["description"] && (
          <span className="add__pretext__validation_error__text">
            {errors["description"]}
          </span>
        )}
      </div>
      <div className="flex flex-ai-c">
        <img
          alt="user_icon"
          className="add__pretext__body_footer_add_to_all_img"
          src={usersIcon}
        />
        <span className="add__pretext__body_footer_add_to_all_title">
          {t("PUBLIC")}
        </span>
        <Switch
          checked={formData.addToAll}
          onChecked={() => handleToggleAddToAll()}
          className="add__pretext__body_footer_add_to_all_switch"
        />
        <span className="add__pretext__body_footer_add_to_all_desc">
          {t("VISIBLE_FOR_ALL")}
        </span>
      </div>
      <div className="flex flex-jc-e add__pretext__body_footer_actions">
        <button
          onClick={() => setPretextsContent("pretexts")}
          className="btn btn-tertiary"
        >
          {t("CANCEL")}
        </button>
        <button onClick={() => handleAddPRetext()} className="btn btn-primary">
          {t("SAVE")}
        </button>
      </div>
    </div>
  );
};

export default AddPretext;
